import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import "./RangeSlider.css";

const propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  progress: PropTypes.number,
};
const defaultProps = {
  min: 0,
  max: 10,
  step: 1,
  progress: 0,
};

const RangeSlider = forwardRef((props, ref) => {
  return (
    <div className='range_slider_container'>
      <label className='range_slider_left_text'>
        {props.min}
      </label>
      <div className='range_slider-slider-container'>
        <input
          className='range_slider'
          min={props.min}
          max={props.max}
          step={props.step}
          type="range"
          ref={ref}
          {...props}
        />
        <div
          className='range_slider_progress'
          style={{ width: `calc(${props.progress * 100}% - ${8 * props.progress}px)` }} />
      </div>
      <label className='range_slider_right_text'>
        {props.max}
      </label>
    </div>
  );
});

RangeSlider.propTypes = propTypes;
RangeSlider.defaultProps = defaultProps;
export default RangeSlider;